import { Component, Input } from '@angular/core';

export type KpiListItem = {
    titleKey: string;
    value: string | number;
    unit: string;
};

@Component({
    selector: 'app-paginated-kpi',
    templateUrl: './paginated-kpi.component.html',
    styleUrls: ['./paginated-kpi.component.scss'],
    standalone: false,
})
export class PaginatedKpiComponent {
    @Input({ required: true }) values!: KpiListItem[];
}
